import React from "react"
import "./NestedPartnerHeader.css"
import defaultPicture from '../../Assets/img/default-partner.jpeg'
import { Button } from "reactstrap"

const NestedPartnerHeader = (props) => {
    const addUrlProtocol = (partnerURL) => {
        return (partnerURL.indexOf("http") >= 0 ? partnerURL : `https://${props.buttonURL}`)
    }

    return(
        <div className="nested-partner-header" 
            onClick={()=>{if (props.onClick){props.onClick()}}}
            style={
                    {
                        width:`${props.width || "100%"}`,
                        height:`${props.height || "150px"}`
                    }
                }
            >
            <div className="nested-container"
                style={
                    {
                        border:`${props.border || "1px lightgray solid"}`
                    }
                }
                >
                <div className="background-filter"
                    style={{backgroundImage:`url( ${props.pictureURL || defaultPicture} )`}} 
                />

                <div className="nested-title"
                    style={
                        {
                            color:`${props.color || "white"}`,
                            fontSize:`${props.fontSize || "medium"}`
                        }
                    }>
                    {props.pictureTitle || "No title !"}
                </div>

                {(props.buttonURL.trim().length > 0) &&
                <div className="nested-button">
                    <Button onClick={()=>{window.open(`${addUrlProtocol(props.buttonURL)}`, "_blank")}}>{props.buttonURL}</Button>
                </div>}

                <div className="nested-logo"
                    style={{backgroundImage:`url( ${props.overlayPartnerLogo || defaultPicture} )`}}
                />

                <div className="event-override-image-container2"
                    style={
                        {
                            backgroundColor:`${props.overlayBackgroundColor || "white"}`
                        }
                    }
                >

                {(props.overlayPartnerName.trim().length > 0) &&
                <div className="partner-name">{props.overlayPartnerName}</div>}

                {(props.overlayPartnerDescritpion.trim().length > 0) &&
                <div className="partner-description">{props.overlayPartnerDescritpion}</div>}

                </div>
            </div>
        </div>
    )
}

export default NestedPartnerHeader